// src/features/api/amadeusApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/amadeusflights`;
export const amadeusApi = createApi({
  reducerPath: "amadeusApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => ({
    searchFlights: builder.query<any, any>({
      query: (params) => ({
        url: "/search",
        method: "POST",
        params,
      }),
    }),
    selectOffer: builder.mutation<any, { offerId: string }>({
      query: ({ offerId }) => ({
        url: "/selectOffer",
        method: "POST",
        body: { offerId },
      }),
    }),
  }),
});

export const { useLazySearchFlightsQuery, useSelectOfferMutation } = amadeusApi;
